import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api, HARBORWELL_LOGO, ROLE_LABELS } from "../lib/api";
import TestAdminBanner from "./TestAdminBanner";
import {
  LayoutDashboard,
  Users,
  ClipboardList,
  FileText,
  Share2,
  BookOpen,
  HandHeart,
  ListChecks,
  BarChart3,
  Settings,
  ShieldCheck,
  Home,
  LogOut,
  Menu,
  X,
  CalendarClock,
  LifeBuoy,
  GraduationCap,
  Plug,
  FileSignature,
  Trash2,
  Inbox,
  Shield,
  Bell,
  Archive,
  ChevronDown,
} from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import QuickAddFab from "./QuickAddFab";
import HelpBeacon from "./HelpBeacon";
import GlobalSearch from "./GlobalSearch";
import CheckInPill from "./CheckInPill";
import { Clock, MapPin, Wrench, ShieldAlert, AlertOctagon, KeyRound, BookOpenCheck, ClipboardCheck, FolderKanban, Building2, BellRing, Command, Mail, FileEdit, History, Target, GripVertical, RotateCcw } from "lucide-react";

export const NAV_ITEMS = [
  // (Iter 76.11) The standalone "Executive Operations" nav item was
  // retired here — the group's primary destination is now Executive
  // Dashboard. The /executive route remains registered in the router
  // for backwards-compat with existing bookmarks / deep links.
  { to: "/", icon: LayoutDashboard, label: "Home", testId: "nav-dashboard", module: "dashboard" },
  { to: "/inbox", icon: Bell, label: "Smart Inbox", testId: "nav-inbox", module: "inbox" },
  { to: "/tasks", icon: ListChecks, label: "Tasks", testId: "nav-tasks", module: "tasks" },
  { to: "/appointments", icon: CalendarClock, label: "Appointments", testId: "nav-appointments", module: "appointments" },
  { to: "/care-seekers", icon: Users, label: "Care Seekers", testId: "nav-care-seekers", module: "care_seekers" },
  { to: "/intake", icon: ClipboardList, label: "A.N.C.H.O.R. Intake", testId: "nav-intake", module: "intake" },
  { to: "/document-templates", icon: FileSignature, label: "Document Templates", testId: "nav-document-templates", module: "document_templates" },
  { to: "/referrals", icon: Share2, label: "Referrals", testId: "nav-referrals", module: "referrals" },
  { to: "/admin/partner-submissions", icon: Inbox, label: "Partner Resource Submissions", testId: "nav-partner-submissions", module: "partner_submissions" },
  { to: "/volunteers", icon: HandHeart, label: "Volunteers", testId: "nav-volunteers", module: "volunteers_admin" },
  { to: "/resources", icon: BookOpen, label: "Community Partner Resources", testId: "nav-resources", module: "resources" },
  { to: "/outreach", icon: HandHeart, label: "Community Outreach", testId: "nav-outreach", module: "outreach" },
  { to: "/timesheets", icon: Clock, label: "Timesheets", testId: "nav-timesheets", module: "timesheets" },
  { to: "/training", icon: GraduationCap, label: "Training", testId: "nav-training", module: "training" },
  { to: "/reports", icon: BarChart3, label: "Reports", testId: "nav-reports", module: "reports" },
  { to: "/analytics/alerts", icon: BellRing, label: "Alerts Center", testId: "nav-alerts-center", module: "community_intel" },
  { to: "/field-checkins", icon: MapPin, label: "Field check-ins", testId: "nav-field-checkins", module: "field_checkins_admin" },
  { to: "/users", icon: Settings, label: "Team Members", testId: "nav-users", module: "users" },
  { to: "/team/caseload", icon: Users, label: "Team Caseload", testId: "nav-caseload", module: "users" },
  { to: "/users/roles", icon: Shield, label: "Roles & permissions", testId: "nav-roles", module: "roles" },
  { to: "/admin/retention", icon: Archive, label: "Data Retention", testId: "nav-retention", module: "retention" },
  { to: "/admin/maintenance", icon: Wrench, label: "Maintenance", testId: "nav-maintenance", module: "maintenance" },
  { to: "/admin/architecture-docs", icon: BookOpen, label: "Architecture & Handoff", testId: "nav-architecture-docs", module: "maintenance" },
  { to: "/admin/compliance", icon: ShieldCheck, label: "Compliance Center", testId: "nav-compliance", module: "compliance" },
  { to: "/admin/compliance-dashboard", icon: LayoutDashboard, label: "Executive Dashboard", testId: "nav-exec-dashboard", module: "exec_dashboard" },
  { to: "/executive/operations", icon: Target, label: "Operations Center", testId: "nav-operations-center", module: "operations_center" },
  { to: "/executive/notifications", icon: BellRing, label: "Notification Center", testId: "nav-exec-notifications", module: "exec_notifications" },
  { to: "/admin/regulatory", icon: ClipboardCheck, label: "Regulatory Frameworks", testId: "nav-regulatory", module: "compliance" },
  { to: "/admin/evidence", icon: FolderKanban, label: "Evidence Management", testId: "nav-evidence", module: "compliance" },
  { to: "/admin/legal-holds", icon: ShieldAlert, label: "Legal Holds", testId: "nav-legal-holds", module: "legal_holds" },
  { to: "/admin/exceptions", icon: AlertOctagon, label: "Exceptions", testId: "nav-exceptions", module: "exceptions" },
  { to: "/admin/governance-keys", icon: KeyRound, label: "Governance Keys", testId: "nav-governance-keys", module: "governance_keys" },
  { to: "/admin/security-center", icon: ShieldCheck, label: "Security Center", testId: "nav-security-center", module: "security_center" },
  { to: "/admin/email-infrastructure", icon: Mail, label: "Email Infrastructure", testId: "nav-email-infra", module: "email_infra" },
  { to: "/admin/email-templates", icon: FileEdit, label: "Email Templates", testId: "nav-email-templates", module: "email_infra" },
  { to: "/admin/change-history", icon: History, label: "Change History", testId: "nav-change-history", module: "change_history" },
  { to: "/admin/partners", icon: Building2, label: "Partner Organizations", testId: "nav-partners", module: "governance_keys" },
  { to: "/admin/partner-applications", icon: ClipboardCheck, label: "Partner Integration Applications", testId: "nav-partner-applications", module: "governance_keys" },
  { to: "/admin/trust-center", icon: ShieldAlert, label: "Trust Center & Digest", testId: "nav-trust-center", module: "governance_keys" },
  { to: "/admin/backup-dr", icon: Archive, label: "Backup & Disaster Recovery", testId: "nav-backup-dr", module: "backup_dr" },
  { to: "/admin/uat", icon: BookOpenCheck, label: "UAT & Release Docs", testId: "nav-uat", module: "release_docs" },
  { to: "/audit", icon: ShieldCheck, label: "Audit Log", testId: "nav-audit", module: "audit" },
  { to: "/integrations", icon: Plug, label: "Integrations", testId: "nav-integrations", module: "integrations" },
  { to: "/tech-support", icon: LifeBuoy, label: "Tech Support", testId: "nav-tech-support", module: "tickets" },
];

export const MOBILE_TABS = [
  { to: "/", icon: LayoutDashboard, label: "Home",       module: "dashboard" },
  { to: "/care-seekers", icon: Users, label: "Seekers",  module: "care_seekers" },
  { to: "/intake", icon: ClipboardList, label: "Intake", module: "intake" },
  { to: "/referrals", icon: Share2, label: "Referrals",  module: "referrals" },
  { to: "/tasks", icon: ListChecks, label: "Tasks",      module: "tasks" },
];

/* -----------------------------------------------------------------------
 * Enterprise-style navigation grouping (Iter 76.2)
 * Purely a UI reorganisation — routes, permissions, testIds and icons are
 * untouched. Items are looked up by testId so the underlying NAV_ITEMS
 * definitions remain the single source of truth.
 * ---------------------------------------------------------------------*/
export const NAV_GROUPS = [
  { key: "workspace",     label: "Workspace",             icon: Home,
    itemIds: ["nav-dashboard", "nav-inbox", "nav-tasks", "nav-appointments",
              "nav-alerts-center"] },
  { key: "care",          label: "Care Management",       icon: Users,
    itemIds: ["nav-care-seekers", "nav-intake", "nav-referrals",
              "nav-document-templates", "nav-caseload",
              "nav-field-checkins"] },
  { key: "community",     label: "Community Engagement",  icon: HandHeart,
    itemIds: ["nav-resources", "nav-outreach", "nav-partner-submissions",
              "nav-volunteers"] },
  { key: "workforce",     label: "Team Operations",       icon: GraduationCap,
    itemIds: ["nav-timesheets", "nav-training", "nav-reports"] },
  { key: "executive",     label: "Executive Operations",  icon: Command,
    itemIds: ["nav-exec-dashboard", "nav-operations-center", "nav-exec-notifications"] },
  { key: "governance",    label: "Governance & Compliance", icon: ShieldCheck,
    itemIds: ["nav-compliance", "nav-regulatory", "nav-evidence",
              "nav-legal-holds", "nav-exceptions", "nav-governance-keys",
              "nav-retention", "nav-audit", "nav-change-history"] },
  { key: "security",      label: "Security",              icon: Shield,
    itemIds: ["nav-security-center", "nav-users", "nav-roles",
              "nav-email-infra", "nav-email-templates", "nav-backup-dr"] },
  { key: "partners",      label: "Partners & Integrations", icon: Building2,
    itemIds: ["nav-partners", "nav-partner-applications", "nav-integrations"] },
  { key: "trust",         label: "Trust Center",          icon: ShieldAlert,
    itemIds: ["nav-trust-center", "nav-uat"] },
  { key: "admin",         label: "Administration",        icon: Wrench,
    itemIds: ["nav-maintenance", "nav-architecture-docs", "nav-tech-support"] },
];

/** testId → group.key lookup (built once). */
const _GROUP_BY_TESTID = NAV_GROUPS.reduce((acc, g) => {
  g.itemIds.forEach((id) => { acc[id] = g.key; });
  return acc;
}, {});

/**
 * Bucketise a role-filtered nav list into the ordered group structure.
 * Items whose testId isn't mapped to a group land in a fallback "other"
 * bucket rendered last (safety net so nothing disappears).
 *
 * `userOrder` (optional) is the caller's persisted preference,
 * `{ [groupKey]: [testId, ...] }`. Items listed there render in that
 * order first; anything unlisted keeps its default position after
 * (safety net for newly-added nav items).
 */
function groupNavItems(items, userOrder = null) {
  const buckets = new Map(NAV_GROUPS.map((g) => [g.key, []]));
  const orphans = [];
  items.forEach((item) => {
    const key = _GROUP_BY_TESTID[item.testId];
    if (key && buckets.has(key)) buckets.get(key).push(item);
    else orphans.push(item);
  });
  const reorderBucket = (groupKey, list) => {
    const preferred = (userOrder && userOrder[groupKey]) || [];
    if (!preferred.length) return list;
    const byId = new Map(list.map((it) => [it.testId, it]));
    const used = new Set();
    const out = [];
    preferred.forEach((tid) => {
      if (byId.has(tid) && !used.has(tid)) {
        out.push(byId.get(tid));
        used.add(tid);
      }
    });
    list.forEach((it) => { if (!used.has(it.testId)) out.push(it); });
    return out;
  };
  const groups = NAV_GROUPS
    .map((g) => ({ ...g, items: reorderBucket(g.key, buckets.get(g.key) || []) }))
    .filter((g) => g.items.length > 0);
  // Warn (dev only) if a NAV_ITEMS entry isn't mapped to any group — this
  // used to render a "More" fallback bucket which could accidentally
  // re-surface a nav item that was intentionally removed. We now
  // silently drop orphans so the sidebar reflects NAV_GROUPS exactly.
  if (orphans.length && typeof console !== "undefined" && process.env.NODE_ENV !== "production") {
    console.warn(
      "[Layout] NAV_ITEMS entries missing from NAV_GROUPS — dropped:",
      orphans.map((o) => o.testId).join(", "),
    );
  }
  return groups;
}

const NAV_OPEN_STORAGE_KEY = "hw_nav_groups_open_v1";

function readOpenGroupsFromSession() {
  try {
    const raw = sessionStorage.getItem(NAV_OPEN_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch { return null; }
}

function writeOpenGroupsToSession(state) {
  try { sessionStorage.setItem(NAV_OPEN_STORAGE_KEY, JSON.stringify(state)); }
  catch { /* storage unavailable */ }
}


export default function Layout({ children }) {
  const { user, logout, canSeeModule } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [newCsCount, setNewCsCount] = useState(0);
  const [pendingPartnerCount, setPendingPartnerCount] = useState(0);
  const [pendingVolunteerCount, setPendingVolunteerCount] = useState(0);
  const [inboxCount, setInboxCount] = useState(0);
  const isDashboard = location.pathname === "/";

  // Track unseen Care Seekers — show a red badge by the Care Seekers nav item
  // whenever new profiles have been added since this user last opened the list.
  const SEEN_KEY = user?.id ? `hw_cs_seen_at_${user.id}` : "hw_cs_seen_at";

  const canSeeCareSeekers = canSeeModule("care_seekers");
  const refreshNewCsCount = async (signal) => {
    // Guard: users without care_seekers.view will 403 on this endpoint.
    // Skipping the request avoids console noise + unnecessary backend load.
    if (!canSeeCareSeekers) return;
    try {
      const since = localStorage.getItem(SEEN_KEY);
      const { data } = await api.get("/care-seekers/new-count", {
        params: since ? { since } : {},
        signal,
      });
      setNewCsCount(data?.count || 0);
    } catch (e) {
      if (e?.name === "CanceledError" || e?.name === "AbortError") return;
      setNewCsCount(0);
    }
  };

  // Partner submissions awaiting admin action (pending_review + info_requested).
  // Only fetched for users whose role can see the Partner Resource Submissions module.
  const canSeePartner = canSeeModule("partner_submissions");
  const refreshPendingPartnerCount = async (signal) => {
    if (!canSeePartner) return;
    try {
      const { data } = await api.get("/admin/partner-submissions/pending-count", { signal });
      setPendingPartnerCount(data?.count || 0);
    } catch (e) {
      if (e?.name === "CanceledError" || e?.name === "AbortError") return;
      setPendingPartnerCount(0);
    }
  };

  // Volunteer signups awaiting admin approval. Only fetched for admin/ED.
  const canSeeVolunteersAdmin = canSeeModule("volunteers_admin");
  const refreshPendingVolunteerCount = async (signal) => {
    if (!canSeeVolunteersAdmin) return;
    try {
      const { data } = await api.get("/admin/volunteers/pending-count", { signal });
      setPendingVolunteerCount(data?.count || 0);
    } catch (e) {
      if (e?.name === "CanceledError" || e?.name === "AbortError") return;
      setPendingVolunteerCount(0);
    }
  };

  // Smart Inbox total — polled every minute for signed-in staff who
  // actually have access to the Inbox module.
  const canSeeInbox = canSeeModule("inbox");
  const refreshInboxCount = async (signal) => {
    if (!canSeeInbox) return;
    try {
      const { data } = await api.get("/inbox/count", { signal });
      setInboxCount(data?.total || 0);
    } catch (e) {
      if (e?.name === "CanceledError" || e?.name === "AbortError") return;
      setInboxCount(0);
    }
  };

  // Sprint 1B-B · US 1.6 · authoritative badge lifecycle
  //
  // React effects and interval callbacks capture their surrounding render's
  // values. Depending only on `user?.id` leaves a stale closure that keeps
  // polling with a permission decision that has since changed. Include each
  // authoritative `canSee*` decision in the dep set so a revocation tears
  // down the previous interval and re-schedules a new one that honours the
  // updated permissions. On revocation, also clear the corresponding local
  // count so a stale count cannot linger in the UI. An AbortController
  // aborts any in-flight response after cleanup.
  useEffect(() => {
    if (!user) return;
    if (!canSeeCareSeekers) setNewCsCount(0);
    if (!canSeePartner) setPendingPartnerCount(0);
    if (!canSeeVolunteersAdmin) setPendingVolunteerCount(0);
    if (!canSeeInbox) setInboxCount(0);

    if (!canSeeCareSeekers && !canSeePartner && !canSeeVolunteersAdmin && !canSeeInbox) {
      return undefined; // nothing to poll — do not schedule an interval
    }

    let cancelled = false;
    const ac = typeof AbortController !== "undefined" ? new AbortController() : null;
    const signal = ac?.signal;
    const tick = () => {
      if (cancelled) return;
      if (canSeeCareSeekers) refreshNewCsCount(signal);
      if (canSeePartner) refreshPendingPartnerCount(signal);
      if (canSeeVolunteersAdmin) refreshPendingVolunteerCount(signal);
      if (canSeeInbox) refreshInboxCount(signal);
    };
    tick();
    const id = setInterval(tick, 60_000); // refresh every minute
    return () => {
      cancelled = true;
      if (ac) { try { ac.abort(); } catch { /* noop */ } }
      clearInterval(id);
    };
  }, [user?.id, canSeeCareSeekers, canSeePartner, canSeeVolunteersAdmin, canSeeInbox]);

  // Mark Care Seekers as "seen" the moment user lands on /care-seekers
  useEffect(() => {
    if (location.pathname.startsWith("/care-seekers")) {
      localStorage.setItem(SEEN_KEY, new Date().toISOString());
      setNewCsCount(0);
    }
    // Refresh the partner badge whenever the user lands on/leaves the queue —
    // admins may have just approved/rejected items.
    if (location.pathname.startsWith("/admin/partner-submissions")) {
      refreshPendingPartnerCount();
    }
    if (location.pathname.startsWith("/volunteers")) {
      refreshPendingVolunteerCount();
    }
    if (location.pathname.startsWith("/inbox")) {
      refreshInboxCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Iter 76 — silently record the last-visited path so users who set their
  // default landing preference to "Last Visited Page" resume where they left
  // off. Backend no-ops for users on any other preset (see /me/preferences).
  useEffect(() => {
    if (!user) return;
    const path = location.pathname + (location.search || "");
    // Skip auth-adjacent routes so we don't resume on /login next time.
    if (path.startsWith("/login") || path.startsWith("/mfa")) return;
    // Debounce so a burst of route changes only fires the last one.
    const t = setTimeout(() => {
      api.put("/me/preferences/last-visited", { path }).catch(() => {});
    }, 800);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, user?.id]);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const visibleNav = NAV_ITEMS.filter((item) => canSeeModule(item.module));
  // US 1.6 · authoritative filtering of the mobile bottom tab bar. Each
  // MOBILE_TABS entry carries its own module key so the same authoritative
  // canSeeModule() decision that gates the desktop sidebar also gates the
  // mobile bar. Denied tabs are not mounted — no residual focusable link.
  const visibleMobileTabs = MOBILE_TABS.filter((tab) => canSeeModule(tab.module));

  // --------------------------------------------------------------------- //
  // Custom nav order (Iter 76.10)                                         //
  //                                                                        //
  // Each user can drag-and-drop items into a preferred order per group.   //
  // The order is stored in the user's preferences document and applied on //
  // top of the default HarborWell Connect layout on every render. Only    //
  // items the user can already see are affected — permissions / routes / //
  // testIds are unchanged.                                                //
  // --------------------------------------------------------------------- //
  const [navOrder, setNavOrder] = useState({});
  const [groupOrder, setGroupOrder] = useState(null); // null = default
  const [customizeMode, setCustomizeMode] = useState(false);
  const [dragging, setDragging] = useState(null); // { kind:'item', groupKey, testId } or { kind:'group', groupKey }

  useEffect(() => {
    if (!user) return;
    api.get("/me/preferences/nav-order")
      .then(({ data }) => {
        setNavOrder(data?.order || {});
        setGroupOrder(Array.isArray(data?.groups) ? data.groups : null);
      })
      .catch(() => { setNavOrder({}); setGroupOrder(null); });
  }, [user]);

  const baseGroups = groupNavItems(visibleNav, navOrder);
  // Apply user's group ordering (falls back to HW Connect default).
  const navGroups = (() => {
    if (!Array.isArray(groupOrder) || groupOrder.length === 0) return baseGroups;
    const byKey = new Map(baseGroups.map((g) => [g.key, g]));
    const used = new Set();
    const out = [];
    groupOrder.forEach((key) => {
      if (byKey.has(key) && !used.has(key)) { out.push(byKey.get(key)); used.add(key); }
    });
    // Any newly-added group not in the saved list appends at the end
    // (forward-compatible with future nav additions).
    baseGroups.forEach((g) => { if (!used.has(g.key)) out.push(g); });
    return out;
  })();

  const persistNavOrder = async (nextOrder, nextGroups = groupOrder) => {
    setNavOrder(nextOrder);
    if (nextGroups !== groupOrder) setGroupOrder(nextGroups);
    try {
      const body = { order: nextOrder };
      if (nextGroups !== undefined) body.groups = nextGroups; // may be null → server preserves
      await api.put("/me/preferences/nav-order", body);
    } catch {
      toast.error("Couldn't save your menu order — please try again.");
    }
  };

  const resetNavOrder = async () => {
    try {
      await api.delete("/me/preferences/nav-order");
      setNavOrder({});
      setGroupOrder(null);
      toast.success("Menu order reset to default.");
    } catch {
      toast.error("Couldn't reset menu order.");
    }
  };

  // Reorder within a single group. Called from onDrop on an item.
  const reorderWithinGroup = (groupKey, sourceTestId, targetTestId) => {
    const group = navGroups.find((g) => g.key === groupKey);
    if (!group) return;
    const ids = group.items.map((it) => it.testId);
    const srcIdx = ids.indexOf(sourceTestId);
    const tgtIdx = ids.indexOf(targetTestId);
    if (srcIdx < 0 || tgtIdx < 0 || srcIdx === tgtIdx) return;
    const next = [...ids];
    next.splice(srcIdx, 1);
    next.splice(tgtIdx, 0, sourceTestId);
    persistNavOrder({ ...navOrder, [groupKey]: next });
  };

  // Reorder whole groups. Called from onDrop on a group header.
  const reorderGroups = (sourceKey, targetKey) => {
    const currentIds = navGroups.map((g) => g.key);
    const srcIdx = currentIds.indexOf(sourceKey);
    const tgtIdx = currentIds.indexOf(targetKey);
    if (srcIdx < 0 || tgtIdx < 0 || srcIdx === tgtIdx) return;
    const nextGroups = [...currentIds];
    nextGroups.splice(srcIdx, 1);
    nextGroups.splice(tgtIdx, 0, sourceKey);
    persistNavOrder(navOrder, nextGroups);
  };

  const handleDragStart = (e, kind, groupKey, testId = null) => {
    setDragging({ kind, groupKey, testId });
    e.dataTransfer.effectAllowed = "move";
    try { e.dataTransfer.setData("text/plain", testId || groupKey); } catch { /* noop */ }
  };
  const handleDragOver = (e) => {
    if (!customizeMode) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };
  const handleDropOnItem = (e, groupKey, targetTestId) => {
    if (!customizeMode) return;
    e.preventDefault();
    const src = dragging;
    setDragging(null);
    if (!src || src.kind !== "item" || src.groupKey !== groupKey) return;
    reorderWithinGroup(groupKey, src.testId, targetTestId);
  };
  const handleDropOnGroup = (e, targetGroupKey) => {
    if (!customizeMode) return;
    e.preventDefault();
    const src = dragging;
    setDragging(null);
    if (!src || src.kind !== "group") return;
    reorderGroups(src.groupKey, targetGroupKey);
  };

  // Iter 76.2 — collapsible groups. State persists for the browser session
  // (sessionStorage) so an expanded/collapsed state survives page refreshes
  // but doesn't leak across users on shared machines.
  // Default (first login, no stored state): collapse everything EXCEPT the
  // group containing the current active route — enterprise-style.
  const [openGroups, setOpenGroups] = useState(() => {
    const stored = readOpenGroupsFromSession();
    if (stored) return stored;
    const init = {};
    NAV_GROUPS.forEach((g) => { init[g.key] = false; });
    init.other = false;
    // Compute the active group from location on first render
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const activeGroupKey = NAV_GROUPS.find((g) => g.itemIds.some((id) => {
      const item = NAV_ITEMS.find((n) => n.testId === id);
      if (!item) return false;
      return item.to === "/" ? path === "/" : path.startsWith(item.to);
    }))?.key;
    if (activeGroupKey) init[activeGroupKey] = true;
    else init.workspace = true; // fallback: Workspace open
    return init;
  });
  useEffect(() => { writeOpenGroupsToSession(openGroups); }, [openGroups]);
  const toggleGroup = (key) =>
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));

  const collapseAll = () => {
    const next = {};
    NAV_GROUPS.forEach((g) => { next[g.key] = false; });
    next.other = false;
    setOpenGroups(next);
  };
  const expandAll = () => {
    const next = {};
    NAV_GROUPS.forEach((g) => { next[g.key] = true; });
    next.other = true;
    setOpenGroups(next);
  };

  // Aggregate notification badges per group so collapsed sections still
  // surface where attention is required (e.g. "Workspace (58)").
  const groupBadgeCount = (group) => {
    let total = 0;
    for (const it of group.items) {
      if (it.to === "/inbox") total += inboxCount || 0;
      else if (it.to === "/care-seekers") total += newCsCount || 0;
      else if (it.to === "/admin/partner-submissions") total += pendingPartnerCount || 0;
      else if (it.to === "/volunteers") total += pendingVolunteerCount || 0;
    }
    return total;
  };

  // Auto-expand the group that contains the active route (so a user landing
  // deep-link'd on a collapsed group doesn't lose their bearing). Only
  // expands — never collapses — so it respects the user's explicit choices.
  useEffect(() => {
    const activeGroup = navGroups.find((g) =>
      g.items.some((it) => (it.to === "/"
        ? location.pathname === "/"
        : location.pathname.startsWith(it.to)))
    );
    if (activeGroup && openGroups[activeGroup.key] === false) {
      setOpenGroups((prev) => ({ ...prev, [activeGroup.key]: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Build a per-item NavLink renderer (identical layout for desktop &
  // mobile, only class overrides differ). Keeps badges/testids/icons
  // exactly as before.
  //
  // In customize mode, each row becomes draggable (native HTML5 DnD) so
  // users can reorder items within their group. Click-to-navigate is
  // suppressed while dragging so drops don't accidentally trigger a
  // route change.
  const renderNavLink = (item, { mobile = false, groupKey = null } = {}) => {
    const isDraggable = customizeMode && !mobile && !!groupKey;
    const dragProps = isDraggable
      ? {
          draggable: true,
          onDragStart: (e) => handleDragStart(e, "item", groupKey, item.testId),
          onDragOver: handleDragOver,
          onDrop: (e) => handleDropOnItem(e, groupKey, item.testId),
          onDragEnd: () => setDragging(null),
        }
      : {};
    const isBeingDragged = dragging?.kind === "item" && dragging?.testId === item.testId;
    return (
      <div key={item.to} {...dragProps}
           className={`${isDraggable ? "cursor-grab active:cursor-grabbing" : ""} ${isBeingDragged ? "opacity-40" : ""}`}
           data-testid={isDraggable ? `drag-${item.testId}` : undefined}>
        <NavLink
          to={item.to}
          end={item.to === "/"}
          /* In customize mode we suppress the anchor's native drag
             behaviour so the outer div is the sole drag source. Anchors
             (<a href>) are draggable by default in HTML5 — without this
             the browser would start a native link-drag and our
             onDragStart / onDrop handlers would never fire, meaning
             the reorder state stays empty and nothing moves.
             Also block pointer events on the inner content so hovering
             over icons/text doesn't cancel the drag. */
          draggable={false}
          onDragStart={isDraggable ? ((e) => e.preventDefault()) : undefined}
          onClick={(e) => {
            if (customizeMode && !mobile) { e.preventDefault(); return; }
            if (mobile) setDrawerOpen(false);
          }}
          data-testid={mobile ? `mobile-${item.testId}` : item.testId}
          className={({ isActive }) =>
            mobile
              ? `flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium ${
                  isActive
                    ? "bg-[#E8ECE7] text-[#1E3A8A]"
                    : "text-[#334155] hover:bg-[#F9F8F6] hover:text-[#1E3A8A]"
                }`
              : `flex items-center gap-3 px-3 py-2 rounded-xl text-[13px] font-medium transition-all
                 focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 ${
                  isActive
                    ? "bg-[#E8ECE7] text-[#1E3A8A]"
                    : "text-[#334155] hover:bg-[#F9F8F6] hover:text-[#1E3A8A]"
                }`
          }
        >
          {isDraggable && (
            <GripVertical className="w-4 h-4 text-[#94A3B8] shrink-0" strokeWidth={1.75}
                          data-testid={`grip-${item.testId}`} />
          )}
          <item.icon className={mobile ? "w-5 h-5" : "w-[18px] h-[18px]"} strokeWidth={1.75} />
          <span className="flex-1">{item.label}</span>
          {item.to === "/care-seekers" && newCsCount > 0 && (
            <span
              data-testid={mobile ? "mobile-nav-care-seekers-badge" : "nav-care-seekers-badge"}
              className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold leading-none"
              title={`${newCsCount} new since you last looked`}
            >
              {newCsCount > 99 ? "99+" : newCsCount}
            </span>
          )}
          {item.to === "/admin/partner-submissions" && pendingPartnerCount > 0 && (
            <span
              data-testid={mobile ? "mobile-nav-partner-submissions-badge" : "nav-partner-submissions-badge"}
          className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold leading-none"
          title={`${pendingPartnerCount} partner submission${pendingPartnerCount === 1 ? "" : "s"} awaiting review`}
        >
          {pendingPartnerCount > 99 ? "99+" : pendingPartnerCount}
        </span>
      )}
      {item.to === "/volunteers" && pendingVolunteerCount > 0 && (
        <span
          data-testid={mobile ? "mobile-nav-volunteers-badge" : "nav-volunteers-badge"}
          className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold leading-none"
          title={`${pendingVolunteerCount} volunteer application${pendingVolunteerCount === 1 ? "" : "s"} awaiting approval`}
        >
          {pendingVolunteerCount > 99 ? "99+" : pendingVolunteerCount}
        </span>
      )}
      {item.to === "/inbox" && inboxCount > 0 && (
        <span
          data-testid={mobile ? "mobile-nav-inbox-badge" : "nav-inbox-badge"}
          className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold leading-none"
          title={`${inboxCount} item${inboxCount === 1 ? "" : "s"} in your inbox`}
        >
          {inboxCount > 99 ? "99+" : inboxCount}
        </span>
      )}
    </NavLink>
      </div>
    );
  };

  const renderGroup = (group, { mobile = false } = {}) => {
    const isOpen = openGroups[group.key] !== false;
    const testId = mobile ? `mobile-nav-group-${group.key}` : `nav-group-${group.key}`;
    const panelId = `${testId}-panel`;
    const badge = groupBadgeCount(group);
    const isGroupDraggable = customizeMode && !mobile;
    const groupDragProps = isGroupDraggable
      ? {
          draggable: true,
          onDragStart: (e) => handleDragStart(e, "group", group.key),
          onDragOver: handleDragOver,
          onDrop: (e) => handleDropOnGroup(e, group.key),
          onDragEnd: () => setDragging(null),
        }
      : {};
    const groupBeingDragged =
      dragging?.kind === "group" && dragging?.groupKey === group.key;
    return (
      <div
        key={group.key}
        className={`mt-5 first:mt-0 ${groupBeingDragged ? "opacity-40" : ""}`}
        data-testid={testId}
      >
        <div
          {...groupDragProps}
          className={`flex items-center gap-1 ${isGroupDraggable ? "cursor-grab active:cursor-grabbing" : ""}`}
          data-testid={isGroupDraggable ? `drag-group-${group.key}` : undefined}
        >
          {isGroupDraggable && (
            <GripVertical
              className="w-4 h-4 text-[#94A3B8] shrink-0"
              strokeWidth={1.75}
              data-testid={`grip-group-${group.key}`}
            />
          )}
          <button
            type="button"
            onClick={() => {
              if (customizeMode && !mobile) return; // in customize mode, header is for dragging
              toggleGroup(group.key);
            }}
            aria-expanded={isOpen}
            aria-controls={panelId}
            data-testid={`${testId}-toggle`}
            className={`flex-1 flex items-center gap-2 px-2.5 py-2 rounded-lg
              text-[12px] font-semibold uppercase tracking-[0.08em]
              transition-colors
              focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 ${
                isOpen
                  ? "text-[#1E3A8A] bg-[#F1F0EA] hover:bg-[#E8ECE7]"
                  : "text-[#475569] hover:bg-[#F9F8F6] hover:text-[#1E3A8A]"
              }`}
          >
            <group.icon className="w-4 h-4" strokeWidth={2} />
            <span className="flex-1 text-left">{group.label}</span>
            {badge > 0 && !isOpen && (
              <span
                data-testid={`${testId}-badge`}
                className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-[#DC2626] text-white text-[10px] font-semibold leading-none"
                title={`${badge} item(s) need attention in ${group.label}`}
              >
                {badge > 99 ? "99+" : badge}
              </span>
            )}
            <ChevronDown
              className={`w-4 h-4 text-[#64748B] transition-transform duration-200 ease-out ${isOpen ? "" : "-rotate-90"}`}
              strokeWidth={2}
              aria-hidden="true"
            />
          </button>
        </div>
        <div
          id={panelId}
          data-testid={`${testId}-items`}
          role="region"
          aria-hidden={!isOpen}
          className="grid overflow-hidden transition-[grid-template-rows] duration-200 ease-out"
          style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
        >
          <div className="min-h-0">
            <div className="pt-1 space-y-1">
              {group.items.map((item) => renderNavLink(item, { mobile, groupKey: group.key }))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex bg-[#F9F8F6]">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex flex-col w-64 bg-white border-r border-[#E5E5E0] sticky top-0 h-screen">
        <div className="px-6 pt-6 pb-4 border-b border-[#E5E5E0]">
          <div className="flex items-center gap-3">
            <img src={HARBORWELL_LOGO} alt="HarborWell" className="h-10 w-auto" />
            <div>
              <div className="font-display font-bold text-[#1E3A8A] text-base leading-none">HarborWell</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-[#1E3A8A] mt-1">Connect</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-3 overflow-y-auto" aria-label="Primary">
          <div className="flex items-center justify-end gap-1 pb-2 border-b border-[#E5E5E0] mb-2 flex-wrap">
            {customizeMode ? (
              <>
                <span className="mr-auto text-[10px] uppercase tracking-wider font-semibold text-[#1E3A8A]"
                      data-testid="nav-customize-hint">
                  Drag items or group headers to reorder
                </span>
                <button
                  type="button"
                  onClick={resetNavOrder}
                  data-testid="nav-reset-order"
                  title="Restore the default HarborWell Connect menu order"
                  className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 transition-colors"
                >
                  <RotateCcw className="w-3 h-3" strokeWidth={2} />
                  Reset
                </button>
                <button
                  type="button"
                  onClick={() => setCustomizeMode(false)}
                  data-testid="nav-customize-done"
                  className="text-[10px] uppercase tracking-wider font-semibold text-white bg-[#1E3A8A] px-2 py-1 rounded hover:bg-[#1E40AF] focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 transition-colors"
                >
                  Done
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  onClick={expandAll}
                  data-testid="nav-expand-all"
                  title="Expand all sections"
                  className="text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 transition-colors"
                >
                  Expand all
                </button>
                <span className="text-[#CBD5E1]" aria-hidden="true">·</span>
                <button
                  type="button"
                  onClick={collapseAll}
                  data-testid="nav-collapse-all"
                  title="Collapse all sections"
                  className="text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 transition-colors"
                >
                  Collapse all
                </button>
                <span className="text-[#CBD5E1]" aria-hidden="true">·</span>
                <button
                  type="button"
                  onClick={() => { setCustomizeMode(true); expandAll(); }}
                  data-testid="nav-customize-toggle"
                  title="Drag and drop menu items into your preferred order"
                  className="text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] focus:outline-none focus:ring-2 focus:ring-[#7E937D]/50 transition-colors"
                >
                  Customize
                </button>
              </>
            )}
          </div>
          {navGroups.map((group) => renderGroup(group))}
        </nav>
        <div className="border-t border-[#E5E5E0] p-4">
          <div className="mb-3">
            <CheckInPill />
          </div>
          <NavLink
            to="/my-account"
            data-testid="nav-my-account"
            className={({ isActive }) =>
              `flex items-center gap-3 mb-3 px-2 py-1.5 -mx-1 rounded-xl transition-colors ${
                isActive ? "bg-[#E8ECE7]" : "hover:bg-[#F9F8F6]"
              }`
            }
          >
            <div className="w-9 h-9 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center text-sm font-semibold">
              {user?.name?.[0]?.toUpperCase() || "?"}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-[#0F172A] truncate">{user?.name}</div>
              <div className="text-xs text-[#1E3A8A] truncate">{user?.title || ROLE_LABELS[user?.role] || user?.role}</div>
            </div>
          </NavLink>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 text-sm py-2 rounded-full border border-[#E5E5E0] text-[#334155] hover:bg-[#F9F8F6] transition-colors"
          >
            <LogOut className="w-4 h-4" strokeWidth={1.75} />
            Sign out
          </button>
        </div>
      </aside>

      {/* Mobile Header */}
      <header className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-white border-b border-[#E5E5E0]">
        <div className="flex items-center justify-between px-4 py-3 gap-2">
          <div className="flex items-center gap-2 flex-shrink-0">
            <img src={HARBORWELL_LOGO} alt="HarborWell" className="h-8 w-auto" />
            <div>
              <div className="font-display font-bold text-[#1E3A8A] text-sm leading-none">HarborWell</div>
              <div className="text-[9px] tracking-[0.2em] uppercase text-[#1E3A8A] mt-0.5">Connect</div>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <CheckInPill />
            <button
              data-testid="mobile-menu-btn"
              onClick={() => setDrawerOpen(true)}
              className="p-2 rounded-full hover:bg-[#F9F8F6]"
            >
              <Menu className="w-5 h-5" strokeWidth={1.75} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      {drawerOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-[#0F172A]/40" onClick={() => setDrawerOpen(false)} />
          <aside className="relative w-72 max-w-[85%] bg-white h-full overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b border-[#E5E5E0]">
              <div className="flex items-center gap-2">
                <img src={HARBORWELL_LOGO} alt="HarborWell" className="h-8" />
                <span className="font-display font-bold text-[#1E3A8A]">HarborWell</span>
              </div>
              <button onClick={() => setDrawerOpen(false)} className="p-2" data-testid="mobile-drawer-close">
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="p-3 space-y-1" aria-label="Primary mobile">
              <div className="flex items-center justify-end gap-1 pb-2 border-b border-[#E5E5E0] mb-2">
                <button
                  type="button"
                  onClick={expandAll}
                  data-testid="mobile-nav-expand-all"
                  className="text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] transition-colors"
                >
                  Expand all
                </button>
                <span className="text-[#CBD5E1]" aria-hidden="true">·</span>
                <button
                  type="button"
                  onClick={collapseAll}
                  data-testid="mobile-nav-collapse-all"
                  className="text-[10px] uppercase tracking-wider font-medium text-[#64748B] px-2 py-1 rounded hover:bg-[#F9F8F6] hover:text-[#1E3A8A] transition-colors"
                >
                  Collapse all
                </button>
              </div>
              {navGroups.map((group) => renderGroup(group, { mobile: true }))}
              <NavLink
                to="/my-account"
                onClick={() => setDrawerOpen(false)}
                data-testid="mobile-nav-my-account"
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium mt-2 border-t border-[#E5E5E0] pt-4 ${
                    isActive ? "text-[#1E3A8A]" : "text-[#334155]"
                  }`
                }
              >
                <Shield className="w-5 h-5" strokeWidth={1.75} />
                My Account
              </NavLink>
              <button
                onClick={handleLogout}
                data-testid="mobile-logout-btn"
                className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-[#334155]"
              >
                <LogOut className="w-5 h-5" strokeWidth={1.75} />
                Sign out
              </button>
            </nav>
          </aside>
        </div>
      )}

      {/* Main Content */}
      <main className="flex-1 min-w-0 pt-16 lg:pt-0 pb-20 lg:pb-0">
        {/* Iter 74.14 — Test admin banner (only shown when session is a
             time-limited approval_test_admin) */}
        <TestAdminBanner user={user} />
        {/* Desktop top bar with global search */}
        <div className="hidden lg:flex sticky top-0 z-20 bg-[#F9F8F6]/95 backdrop-blur-sm border-b border-[#E5E5E0] px-8 py-3 items-center gap-4">
          <GlobalSearch />
        </div>
        {/* Mobile: search just below the fixed header */}
        <div className="lg:hidden px-4 pt-3 pb-2 bg-[#F9F8F6]">
          <GlobalSearch />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10">
          {!isDashboard && (
            <button
              onClick={() => navigate("/")}
              data-testid="home-btn"
              className="inline-flex items-center gap-1.5 text-sm text-[#1E3A8A] hover:text-[#1E3A8A] mb-4 transition-colors"
            >
              <Home className="w-4 h-4" strokeWidth={1.75} />
              Home
            </button>
          )}
          {children}
        </div>
      </main>

      {/* Mobile Bottom Tab Bar — US 1.6 · authoritative canSeeModule filtering.
          The <nav> landmark is NOT rendered when zero tabs are authorised so
          screen readers don't announce an empty navigation region. */}
      {visibleMobileTabs.length > 0 && (
        <nav
          className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-[#E5E5E0]"
          data-testid="mobile-nav"
        >
          <div className="grid grid-cols-5">
            {visibleMobileTabs.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.to === "/"}
                data-testid={`bottomtab-${tab.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-medium relative ${
                    isActive ? "text-[#1E3A8A]" : "text-[#1E3A8A]"
                  }`
                }
              >
                <div className="relative">
                  <tab.icon className="w-5 h-5" strokeWidth={1.75} />
                  {tab.to === "/care-seekers" && newCsCount > 0 && (
                    <span
                      data-testid="bottomtab-care-seekers-badge"
                      className="absolute -top-1.5 -right-2 inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 rounded-full bg-[#DC2626] text-white text-[9px] font-semibold leading-none"
                    >
                    {newCsCount > 9 ? "9+" : newCsCount}
                  </span>
                  )}
                </div>
                {tab.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}

      <QuickAddFab />
      <HelpBeacon />
    </div>
  );
}
